import { render, staticRenderFns } from "./SelectedFabric.vue?vue&type=template&id=8b9af562&"
import script from "./SelectedFabric.vue?vue&type=script&lang=js&"
export * from "./SelectedFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports